import { FormItemProps, InputProps } from 'antd';
import { TextAreaProps } from 'antd/es/input';
import { OptionProps, SelectProps } from 'antd/es/select';
import { ReactElement } from 'react';
import { Noop, UseControllerProps } from 'react-hook-form';
import { FormFileProps } from './components/Form/FormFile';

export enum FieldType {
  Select = 'Select',
  Divider = 'Divider',
  TextArea = 'TextArea',
  DateAndTime = 'DateAndTime',
  Date = 'Date',
  File = 'File',
  FileUpload = 'FileUpload',
  Base = 'Base',
  Password = 'Password',
  Custom = 'Custom',
}

export interface FieldBase {
  key: string;
  fields?: Field[];
  inputProps?: InputProps;
  type?: undefined;
  label?: string;
  required?: boolean;
  itemProps?: FormItemProps;
  disabled?: boolean;
  onChange?: (val: any) => void;
  className?: string;
  rules?: UseControllerProps['rules'];
  hasLabel?: boolean;
}

export interface SelectOption {
  value: string;
  label: string;
}

export interface FieldSelect extends Omit<FieldBase, 'type' | 'inputProps'> {
  options: (OptionProps | SelectOption)[];
  inputProps?: SelectProps;
  type: FieldType.Select;
}

export interface FieldDivider extends Omit<FieldBase, 'type' | 'inputProps'> {
  type: FieldType.Divider;
  inputProps?: undefined;
  required?: undefined;
}

export interface FieldTextArea extends Omit<FieldBase, 'type' | 'inputProps'> {
  type: FieldType.TextArea;
  inputProps?: TextAreaProps;
}

export interface FieldDateAndTime extends Omit<FieldBase, 'type'> {
  type: FieldType.DateAndTime;
}

export interface FieldDate extends Omit<FieldBase, 'type'> {
  type: FieldType.Date;
}

export interface FieldPassword extends Omit<FieldBase, 'type'> {
  type: FieldType.Password;
}

export interface FieldFile extends Omit<FieldBase, 'type' | 'inputProps'> {
  type: FieldType.File;
  inputProps?:
    | Partial<FormFileProps>
    | ((params: { value: FormFileProps['value'] }) => Partial<FormFileProps>);
}

export interface FieldFileUpload extends Omit<FieldBase, 'type'> {
  type: FieldType.FileUpload;
}

interface FieldCustomRender {
  onChange: (...event: any[]) => void;
  onBlur: Noop;
  value: any;
}
export interface FieldCustom extends Omit<FieldBase, 'type'> {
  type: FieldType.Custom;
  render: (params: FieldCustomRender) => ReactElement;
}

export type Field =
  | FieldBase
  | FieldSelect
  | FieldDivider
  | FieldTextArea
  | FieldDateAndTime
  | FieldDate
  | FieldFile
  | FieldFileUpload
  | FieldPassword
  | FieldCustom;

export interface StateLoading<Type> {
  isLoading?: boolean;
  data?: Type;
  error?: string;
}
